<style scoped src= "./Login.css"></style>

<template>
  <v-main class="hola">
  <v-row align="center" justify="center" class="login">
    <v-col cols="12" align="center" justify="center" v-if="isLicense">
      <!--<v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <img src="../assets/images/logoXpectra.png" class="logoLogin" v-bind="attrs" v-on="on">
        </template>
        <span>{{versionBack}}</span><br>
        <span>{{nameHost}}</span>
      </v-tooltip>-->
      <h3 class="">{{ $t('lang.login.SUBCONSOLA') }}</h3>
  
      <!--<v-btn color="#001f3faf"  width="300px" style="margin-top:40px" :disabled="!(valid && !overlay)" @click="authorize()">{{$t('lang.login.LOGIN_SIGIN')}}</v-btn>-->
      <!--<v-btn text  :disabled="overlay" color="rgba(255, 255, 255, 0.46)">{{ $t('lang.login.PASSWORDFORGOT') }}</v-btn>-->
      <div class="text-center ma-12">
        <v-progress-circular v-if="overlay"
            :indeterminate="true"
            rotate="0"
            :size="60"
            :value="0"
            :width="4"
            color="white"
          ></v-progress-circular>
        </div>
    </v-col>
    <v-col cols="12" align="center" justify="center" v-if="!isLicense">
      
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <img src="../assets/images/LogoXsite.png" class="logoLogin" v-bind="attrs" v-on="on">
        </template>
        <span>{{versionBack}}</span><br>
        <span>{{nameHost}}</span>
      </v-tooltip>
      <h2>{{$t('lang.login.NO_LICENSE')}}</h2>
      <h2>{{$t('lang.login.CONTACT_XPECTRA')}}</h2>      
    </v-col>
  </v-row>
</v-main>
  
</template>

<script>
export default {
  name:'Login',
  data: () =>({
    overlay: false,
    user:'',
    password:'',
    valid:true,
    error:'',
    errorconexion:false,
    isLicense:true,
    version:'',
    host:'',
    shouldDisable: true
  }),
  watch:{
    user: function(){
        //console.log(this.user)
    }
  },
  computed:{
    versionBack(){
      var cadena;
      cadena = 'Version back: ' + this.version;
      return cadena
    },
    nameHost(){
      var cadena;
      cadena = 'Nombre del host: ' + this.host;
      return cadena
    }
  },
  async mounted(){
    this.$store.dispatch("logout")
    //Logging from Azure
    var idtoken = sessionStorage["msal.idtoken"];
    if(idtoken){
      //sessionStorage.clear()
      this.$store.dispatch("saveToken", {token: idtoken, expire: this.$moment().unix()+4000})
      this.$store.dispatch("saveHabilitado", true)
      this.$router.push({path : "/"})
    }
    else{
      this.overlay = true;
      setTimeout(this.authorize, 2000)
      //this.authorize()
    }
  },
  methods:{
    enableUser(){
        this.shouldDisable = false
    },
    async getUser(username){
      this.overlay = true;
      //console.log(username)
      await this.$LoginService.getUser(username)
      .then(response => {
          this.overlay = false;
          //console.log('RESPONSE',response);

          if(response.Habilitado){
            var currentUser = {
              nombre : response.Nombre,
              cargo : response.Cargo,
              foto : response.Foto == null ? '' : 'data:image/png;base64,' + response.Foto,
              ubicacionActual : response.UbicacionActual,
              IdUbicacionActual: response.IdUbicacionActual,
              sucursales : response.Sucursales,
              permisos: this.$LoginService.getPermisos(response.PermisosUsuario)
            }

            this.$store.dispatch("saveIpStreamingCentral", response.IpStreamingCentral)
            this.$store.dispatch("saveHabilitado", response.Habilitado)
            this.$store.dispatch("saveCurrentUser", currentUser)
            this.$store.dispatch("saveCurrenSucursal", { "ubicacionActual": response.UbicacionActual, "IdUbicacionActual" : response.IdUbicacionActual})

            if (!currentUser.permisos.tickets.acceso && !currentUser.permisos.alarmas.acceso && !currentUser.permisos.videos.acceso) {
                if (currentUser.permisos.registro.acceso) {
                    this.$router.push({name : "Registro"});
                    return;
                }
            }
            this.$router.push({name : 'Home'})
          }
          
      })
      .catch(error => {
          this.overlay = false;
          //console.log(error)
      });
    },
    async logout(){
        await this.$AuthService.logout().then(
          token => {
            //console.log("JWT token ", token)
          },
          error => {
            //console.log("Login error " + error)
          }
        )
    },
    async authorize(){
      this.overlay = true;

      this.$AuthService.loginRedirect();

      /*await this.$AuthService.login().then(
        token => {
          this.overlay = false;
          this.$store.dispatch("saveToken", {token: token.idToken.rawIdToken, expire: token.idToken.expiration})
          this.$store.dispatch("saveHabilitado", true)
          this.$router.push({name : 'Home'})

          //console.log("JWT token ", token)
        },
        error => {
          this.overlay = false;
          //console.log("Login error " + error)
        }
      )*/
    },
  }
}
</script>